module.exports = __webpack_public_path__ + "static/img/基于感湿材料的土壤含水量测量装置.baa33f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/基于感湿材料的土壤含水量测量装置.jpg
// module id = Rc6Y
// module chunks = 15